import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import LearningTracksAction from '../../redux/actions/learningTracks/LearningTracksAction'
import ModalHeader from './ModalHeader'
import { BuildPath } from '../../helpers/Paths'
import { IRootState } from 'redux/reducers'

import '../../css/IntroModal.scss';

type Props = {
    showWorkspaces: () => void,
    openHelpCentre: () => void
}

const IntroModalContent = (props: Props) => {

    const dispatch = useDispatch()

    const profileImage = useSelector((state: IRootState)  => state.profile.profileImage)

    const userName = useSelector((state: IRootState)  => state.profile.userName)
    let title =  userName === null ? 'Welcome to Thrive home' : `Hi, ${userName}`;

    const textIcon = "👋";

    useEffect(() => {
        // Intro modal has been seen
        dispatch(LearningTracksAction.setIntroModalViewed())
    }, [dispatch])

    return (
        <section className="intro-modal">

            <ModalHeader title={title} text='How would you like to get started?' imageURL={profileImage} textIcon={textIcon} cssClass="intro-modal-header" />
       
            <div className="intro-selection">

                {/* Help center closes modal */}
                <section onClick={() => props.openHelpCentre()}>                
                    <div className="thriveRecommends">
                        <img className='chevron' src={`${BuildPath()}/images/icons/star.svg`} />
                        Thrive recommends!
                    </div>

                    <img src={`${BuildPath()}/images/modal/LearnIcon.png`} alt="" />
                    <h2>Learn</h2>
                </section>

                {/* Pick workspace */}
                <section onClick={() => props.showWorkspaces()}>
                    <img src={`${BuildPath()}/images/modal/BuildIcon.png`} alt="" />
                    <h2>Build</h2>
                </section>
                
                <div className="section-intro">
                    Browse our help centre for guidance on setting up and manageing your employee app.
                </div>

                <div className="section-intro">
                    Jump right into a workspace and start adding the content to your app
                </div>
 
            </div>

        </section>
    );
};

export default IntroModalContent;